module.exports = __webpack_public_path__ + "img/relation_shape3.2fe3b2f.svg";